import * as React from "react";

const ProductListingsProp65: React.FC = () => {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g fill="none" fillRule="evenodd" transform="translate(1 2)">
                <polygon fill="#FBD336" fillRule="nonzero" points="16 14.5 2 14.5 9 2.5 16 14.5" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M0,16 L1.94414073,16 L16.0558603,16 L18,16 L17.0367195,14.2857143 L9.97031325,1.72857121 L9,0 L8.02968782,1.72857121 L0.963281572,14.2857143 L0,16 Z M15,14 L3,14 L9,3 L15,14 L15,14 Z M8,9.14285714 L8,10 L10,10 L10,9.14285714 L10,6 L8,6 L8,9.14285714 Z M10,13 L10,11 L8,11 L8,13 L10,13 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(ProductListingsProp65);
